import { Box, Skeleton } from '@mui/material';
import React from 'react';
import { TextSkeleton } from 'src/sections/@dashboard/warehouse/components/WarehouseDetailDialogSkeleton';
import { SPAN_FULL } from './medicationFormLayout';

/**
 * MedicationStockBatchField while the Product's batches load: the "Partia"
 * select and the automatic pick's line under it.
 */
export default function MedicationStockBatchFieldSkeleton(): React.ReactElement {
  return (
    <Box sx={SPAN_FULL} data-testid="medication-stock-batch-skeleton">
      <Skeleton variant="rounded" height={56} sx={{ borderRadius: 1 }} />
      <TextSkeleton
        variant="caption"
        width={240}
        sx={{ display: 'block', mt: 0.5 }}
      />
    </Box>
  );
}
